import { isUnifiedInboxFolder } from "owa-unified-inbox-data-utils/lib/isUnifiedInboxFolder";
import type { MailFolderTableQuery, TableView } from "owa-mail-list-store";
import { type TableQueryType, getStore as getListViewStore } from "owa-mail-list-store";
import folderIdToName from "owa-session-store/lib/utils/folderIdToName";

export interface GetAllTableViewsContainingItemsForFolderState {
    tableViews: Map<string, TableView>;
}

/**
 * Get all the table views that may contain items from the given folder
 * @param the folder id
 * @param shouldIncludeSearchTable - whether to include the search table in the table list being returned
 * @param the GetAllTableViewsContainingItemsForFolderState used for getAllTableViews
 */
export default function getAllTableViewsContainingItemsForFolder(folderId: string, shouldIncludeSearchTable: boolean, state: GetAllTableViewsContainingItemsForFolderState = {
    tableViews: getListViewStore().tableViews,
}): TableView[] {
    const { tableViews } = state;
    const allTableViewsOfFolder: TableView[] = [];
    for (const tableView of tableViews.values()) {
        if (!shouldIncludeSearchTable && tableView.tableQuery.type === 1) {
            continue;
        }
        
        const satisfyUnifiedInboxTable = isUnifiedInboxFolder(tableView.tableQuery.folderId) &&
            folderIdToName(tableView.tableQuery.folderId) === folderIdToName(folderId);
        
        // Include search table if specified
        if (tableView.tableQuery.folderId === folderId ||
            tableView.serverFolderId === folderId ||
            (shouldIncludeSearchTable && tableView.tableQuery.type === 1) ||
            satisfyUnifiedInboxTable) {
            allTableViewsOfFolder.push(tableView);
        }
        else if (shouldIncludeSearchTable) {
            // favorited category and persona folders are of mail table query type, except when it's initially
            // created, which issues a search table query as fallback instead
            // search tables are not only returned by search table query calls, they can also be returned
            // by the FindItem/FindConversation mail table query calls
            const mailTableQueryScenario = (tableView.tableQuery as MailFolderTableQuery)
                .scenarioType;
            if (mailTableQueryScenario === "category" ||
                mailTableQueryScenario === "persona" ||
                mailTableQueryScenario === "privatedistributionlist") {
                allTableViewsOfFolder.push(tableView);
            }
        }
    }
    return allTableViewsOfFolder;
}
